import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Employee } from '..';
import { EmployeeSkillsCard } from '../../../pages/Skills';
import { EmployeeTargetProfile } from '../EmployeeTargetProfile';

type Props = {
  employee: Employee;
};

export const EmployeeSkills: React.FC<React.PropsWithChildren<Props>> = ({
  employee,
}) => {
  return (
    <Row>
      <Col lg={8}>
        <EmployeeSkillsCard
          employeeId={employee.Id}
          employeeName={employee.Name}
        />
      </Col>
      <Col lg={4}>
        <EmployeeTargetProfile employee={employee} />
      </Col>
    </Row>
  );
};
